module.exports = __webpack_public_path__ + "img/BACKGROUND-ORCHIDEE-nogutter@2x.4a6e8c48.jpg";